import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyapphomebody} from './/bodyapphomebody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './/withRouter'
class Bodyapphome extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyapphomebody/>
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyapphome);